// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__u8Ytw","buttons":"Footer_buttons__2f95K"};